import { ValueUtils } from '../../utils/ValueUtils';
import DOMUtils from './../../utils/DOMUtils';

class Highlighter {
    //Helper text used if there are multiple occurences of the same text
    public highlight(htmlElement: HTMLElement, text: string, highlightedClass: string, restClass = "", helperText = "", additionalAttributesMap: {} = {}) {
      if(!htmlElement){ return; }
      
      const $htmlElement = $(htmlElement);

      //If already played, simply highlight the text
      if($htmlElement.is(".fragment-played")) { restClass = ""; }

      const textNodes = DOMUtils.getAllDescendantTextNodes(htmlElement);
      const textNodeTextRanges = DOMUtils.createTextNodeTextRanges(textNodes);

      let queryStartIndex = ValueUtils.getStartIndex(textNodeTextRanges.value, text, helperText);
      let queryEndIndex = queryStartIndex + text.length;

      if(queryStartIndex === -1) {
        //Query string not found, try to recover
        //(e.g maybe we've done a replacement to handle the display of html nodes)
        queryStartIndex = textNodeTextRanges.value.indexOf(text.replace("<", "&lt;").replace(">", "&gt;"));
        queryEndIndex = queryStartIndex + text.length;

        if(queryStartIndex == -1) { return; }
      }

      const ranges = DOMUtils.splitRanges(textNodeTextRanges, queryStartIndex, queryEndIndex);

      this.markVisibleParentNodeElements(htmlElement, ranges.followingRanges, restClass);

      this.liftWordsInMatchingRanges(ranges.matchingRanges, queryStartIndex, queryEndIndex, highlightedClass, restClass, additionalAttributesMap);
      this.liftWordsInFollowingRanges(ranges.followingRanges, restClass);

      if(restClass.trim() != "") {
        const restClassesClassified = "." + restClass.trim().replace(/\s+/, ".");

        $htmlElement.find(restClassesClassified).each(function(index, element) {
          const $nextSibling = $(element.nextSibling);
          if($nextSibling.is("img")) { $nextSibling.addClass(restClass);}
        });
      }
    }

    private liftWordsInMatchingRanges(ranges, queryStartIndex, queryEndIndex, highlightedClass, restClass, additionalAttributesMap: {}) {
        for(let i = 0, length = ranges.length; i < length; i++) {
            const range = ranges[i];
            const wholeRangeString = range.textNode.nodeValue;

            if(i == 0) {
                const modifiedStartIndex = queryStartIndex - range.start;
                const modifiedEndIndex = queryEndIndex - range.start;

                const keptSubstring = wholeRangeString.substring(0, modifiedStartIndex);
                const modifiedSubstring = wholeRangeString.substring(modifiedStartIndex, modifiedEndIndex);
                const restSubstring = wholeRangeString.substring(modifiedEndIndex, range.end);

                $(range.textNode).replaceWith(
                    keptSubstring
                    + DOMUtils.wrapToHtmlElement("span", { class: highlightedClass, ...additionalAttributesMap}, modifiedSubstring)
                    + ((restSubstring != "" && restClass != "") ? DOMUtils.wrapToHtmlElement("span", { class: restClass}, restSubstring) : restSubstring)
                );
            }
            else if(i == length - 1) {
                const restStartIndex = queryEndIndex - range.start;

                const modifiedSubstring = wholeRangeString.substring(0, restStartIndex);
                const restSubstring = wholeRangeString.substring(restStartIndex, wholeRangeString.length);

                $(range.textNode).replaceWith(
                    DOMUtils.wrapToHtmlElement("span", { class: highlightedClass, ...additionalAttributesMap}, modifiedSubstring)
                    + ((restSubstring != "" && restClass != "") ? DOMUtils.wrapToHtmlElement("span", { class: restClass}, restSubstring) : restSubstring)
                );
            }
            else {
                $(range.textNode).replaceWith(
                    DOMUtils.wrapToHtmlElement("span", { class: highlightedClass, ...additionalAttributesMap }, wholeRangeString)
                );
            }
        }
    }

    private liftWordsInFollowingRanges(ranges, restClass) {
        if(!restClass) { return; }
        for(let i = 0; i < ranges.length; i++) {
            const range = ranges[i];

            if(range.textNode.nodeValue && range.textNode.nodeValue.trim()){
                $(range.textNode).replaceWith(
                    DOMUtils.wrapToHtmlElement("span", { class: restClass}, range.textNode.nodeValue)
                );
            }
        }
    }

    private markVisibleParentNodeElements(mainElement, ranges, restClass) {
        if(!mainElement || !ranges || ranges.length == 0 || !restClass) { return; }

        for(let i = 0; i < ranges.length; i++) {
            const range = ranges[i];
            const textNode = range.textNode;
            if(textNode.parentNode.nodeName == "KBD") {
                $(textNode.parentNode).addClass(restClass);
            }
        }
    }
}

export default new Highlighter();